import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { fetchPatientsByName } from '@store/actions'

interface Patient {
  patient_id: string
  first_name: string
  last_name: string
}
// Define the initial state
interface PatientState {
  patients: Patient[]
  loading: boolean
  error: string | null
}

const initialState: PatientState = {
  patients: [],
  loading: false,
  error: null,
}

const patientSlice = createSlice({
  name: 'patients',
  initialState,
  reducers: {
    clearError(state) {
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Patients - Pending
      .addCase(fetchPatientsByName.pending, (state) => {
        state.loading = true
        state.error = null
      })
      // Fetch Patients - Fulfilled
      .addCase(
        fetchPatientsByName.fulfilled,
        (state, action: PayloadAction<Patient[]>) => {
          state.loading = false
          state.patients = action.payload
        },
      )
      // Fetch Patients - Rejected
      .addCase(fetchPatientsByName.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
  },
})

export default patientSlice.reducer
